module.exports = __webpack_public_path__ + "img/traumatology.ea0c256b.svg";